import { ref, onMounted, onUnmounted, reactive } from 'vue';
import { bookingJobEventsService } from '@/api/booking-job-events.service';
import type { BookingJobEvent } from '@carvia/ros-client-types';
import type { ServerSentEventService } from '@/api/server-sent-event.service';

export function useBookingJobEvents(bookingId: string) {
  const events = reactive<BookingJobEvent[]>([]);
  const error = ref<Error | null>(null);
  const isConnected = ref(false);

  let subscription: { unsubscribe: () => void } | null = null;
  let service: ServerSentEventService<BookingJobEvent> | null = null;

  onMounted(() => {
    service = bookingJobEventsService(bookingId);
    subscription = service.open().subscribe({
      next: (event) => {
        events.push(event);
      },
      error: (err) => {
        error.value = err;
        isConnected.value = false;
      },
      complete: () => {
        isConnected.value = false;
      },
    });
    isConnected.value = true;
  });

  onUnmounted(() => {
    if (subscription) {
      subscription.unsubscribe();
    }
    service?.close();
  });

  return {
    events,
    error,
    isConnected,
  };
}
